// socketThunks.js
import { io } from "socket.io-client";
import { setIsConnected, setSocket } from "../Redux/slices/SocketSlice";

const SOCKET_URL =
  process.env.REACT_APP_PUBLIC_BASE_URL || "http://localhost:3000";

let socketInstance = null;

export const connectWebSocket = () => (dispatch) => {
  if (socketInstance) {
    console.log("Socket already connected.");
    return;
  }

  const socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
  });

  socketInstance = socket;

  dispatch(setSocket(socket));

  socket.on("connect", () => {
    console.log("Connected to server:", socket.id);
    dispatch(setIsConnected(true));
  });

  socket.on("disconnect", (reason) => {
    console.warn("Disconnected from server:", reason);
    dispatch(setIsConnected(false));
  });

  socket.on("connect_error", (error) => {
    console.error("Connection error:", error);
    dispatch(setIsConnected(false));
  });
};

export const getSocket = () => socketInstance;
